"use client";

import React from "react";
import { StandardizedFAB } from "@/components/ui/standardized-fab";

interface FloatingActionButtonProps {
  onClick: () => void;
  icon: React.ReactNode;
  label?: string;
  className?: string;
  size?: "sm" | "md" | "lg";
  variant?: "default" | "primary" | "secondary";
  disabled?: boolean;
}

/**
 * Thin wrapper around the canonical {@link StandardizedFAB}. Kept for callers
 * (e.g. `EntityPageHeader`) that supply an explicit icon node + label. New code
 * should prefer `StandardizedFAB` (or its `Create*FAB` presets) directly.
 *
 * Previously this rendered its own button with `bg-brand-blue` — a color that is
 * not defined in the Tailwind config, so the FAB rendered white-on-white (only
 * the outline visible). Delegating guarantees the branded, visible styling.
 */
export function FloatingActionButton({
  onClick,
  icon,
  label,
  className,
  size = "md",
  variant = "primary",
  disabled = false,
}: FloatingActionButtonProps) {
  return (
    <StandardizedFAB
      onClick={onClick}
      icon={icon}
      label={label ?? "Create"}
      className={className}
      size={size}
      variant={variant}
      disabled={disabled}
      showTooltip={Boolean(label)}
    />
  );
}
